<template>
    <div class="auth-succ-container">
        <div class="auth-succ-title">
            <i class="el-icon-success success-icon"></i>
            <span class="succ-text">印章授权完成</span>
        </div>
        <div class="auth-succ-content">
            <div class="auth-succ-child">
              <div
                class="auth-succ-content-desc"
                v-for="(content,index) in succContent" :key="index">
                  {{ content }}
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getContractOrgDetail } from '@/api/domain/organize'

export default {
  props: {
    orgId: {
      type: String,
      default: '',
    },
    reNew: {
      type: Number,
    },
  },
  data() {
    return {
      succContent: [],
    }
  },
  methods: {
    async getSuccContent() {
      const { code, data } = await getContractOrgDetail({
        orgId: this.orgId,
        reNew: this.reNew,
      })

      if (code === 1) {
        this.succContent = [
          `企业主体全称: ${data.orgName}`,
          `统一社会信用代码证号: ${data.orgIdCardNum}`,
          `授权印章名称: ${data.sealName}`,
          `授权印章类型: ${data.sealTypeName}`,
          `授权失效日期: ${data.expireTime}`,
        ]
      }
    },
  },
  created() {
    this.getSuccContent()
  },
}
</script>

<style lang="scss" scoped>
.auth-succ-container {
  text-align: center;
}
.auth-succ-title {
  .success-icon {
    position: relative;
    top: 5px;
  }
  .el-icon-success:before {
    color: #32B754;
    font-size: 30px;
  }
  .succ-text {
    font-size: 16px;
    font-weight: bold;
  }
}
.auth-succ-content {
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .auth-succ-child {
    text-align: center;
    .auth-succ-content-desc {
    font-size: 14px;
    font-weight: bold;
    line-height: 28px;
  }
  }

}
</style>
